<script lang="ts">
	import { ZmsFb } from "@core/utils/ZmsFb.js";
	import image from "../assets/aboutUs/fb.png?webp&w=620&imagetools";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./FbHiring.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const translate = getTranslate(translations);
</script>

<section class="full-width bg-zms-grey grid-container">
	<div class="container-center flex items-center flex-col gap-11 lg:gap-[5.5rem]">
		<h2 class="hidden md:inline-block lg:hidden"><Formatted text={translate("heading")} /></h2>
		<div class="lg:grid flex md:grid md:grid-cols-2 flex-col-reverse lg:grid-cols-2 gap-6 w-full">
			<Media height={620} width={519} alt={translate("heading")} source={{ src: image, type: "image/png" }} />
			<div class="flex flex-col md:hidden lg:flex gap-8 lg:gap-10">
				<h2><Formatted text={translate("heading")} /></h2>
				<p class="font-medium lg:text-lg/[1.4] text-optical-black">
					<Formatted text={translate("text")} />
				</p>
				<div class="lg:block hidden">
					<Link href={ZmsFb} target="_blank" variant={ButtonVariant.OutlinedWithIcon}>
						<TextWithIcon><Formatted text={translate("buttonText")} /></TextWithIcon>
					</Link>
				</div>
			</div>
			<p class="font-medium text-md/[1.35] lg:text-lg/[1.4] text-optical-black hidden md:block lg:hidden">
				<Formatted text={translate("text")} />
			</p>
		</div>
		<div class="lg:hidden w">
			<Link href={ZmsFb} target="_blank" variant={ButtonVariant.OutlinedWithIcon}>
				<TextWithIcon><Formatted text={translate("buttonText")} /></TextWithIcon>
			</Link>
		</div>
	</div>
</section>
